import { render, staticRenderFns } from "./login-header.component.vue?vue&type=template&id=3f55d5f6&scoped=true&"
import script from "./login-header.component.vue?vue&type=script&lang=ts&"
export * from "./login-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./login-header.component.vue?vue&type=style&index=0&id=3f55d5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f55d5f6",
  null
  
)

export default component.exports